import { UuidV7 } from '../identity/uuidv7-generator.js';

export interface HelperEnrollmentOptions {
  clusterId: string;
  masterNodeId: string;
  masterSpkiFingerprint: string;
  roles: string[];
  maxRamGb: number;
  maxCpuPercent: number;
  maxStorageGb: number;
  ttlSeconds: number;
}

export class MasterEnrollmentIssuer {
  /**
   * Generates a deep link URI intended to be intercepted by the helper node's OS.
   */
  static generateDeepLink(options: HelperEnrollmentOptions): string {
    const expiresAt = new Date(Date.now() + options.ttlSeconds * 1000).toISOString();
    
    // In a real scenario, this token would be a signed JWT or similar cryptographic lease 
    // issued by the master's private key. For this sprint, we simulate a secure random token.
    const rawToken = `enc_tok_${UuidV7.generate().replace(/-/g, '')}`;

    const url = new URL('mesh://helper-enroll/');
    url.searchParams.set('cluster', options.clusterId);
    url.searchParams.set('master', options.masterNodeId);
    url.searchParams.set('spki', options.masterSpkiFingerprint);
    url.searchParams.set('roles', options.roles.join(','));
    url.searchParams.set('ram', options.maxRamGb.toString());
    url.searchParams.set('cpu', options.maxCpuPercent.toString());
    url.searchParams.set('storage', options.maxStorageGb.toString());
    url.searchParams.set('exp', expiresAt);
    url.searchParams.set('token', rawToken);

    return url.toString();
  }
}
